import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notfound',
  templateUrl: './404.component.html',
  styleUrls: ['./404.component.scss'],
})
export class NotFound {
  constructor(private route: Router) {}

  redirectHome() {
    this.route.navigate(['/home']);
  }
}
